module.exports = __webpack_public_path__ + "media/logos/lexshares-black-0e5fd2f6.png";